import { createReducer } from 'app-webtech-core/reducers/createReducer';
import { CONFIGURE } from '../actions/types';
import { deviceConfigureReducer } from './configure';

export const defaultState = {
  ID: null,
  type: null,
  make: null,
  version: null,
  userAgent: null,
  DNT: true,
  isConfigured: false,
  error: null,
};

export const deviceReducer = createReducer(defaultState, {
  [CONFIGURE]: deviceConfigureReducer,
});
